import { jsx as e } from "react/jsx-runtime";
function i(l) {
  return /* @__PURE__ */ e("svg", { fill: "none", height: "1em", viewBox: "0 0 39 39", width: "1em", xmlns: "http://www.w3.org/2000/svg", ...l, children: /* @__PURE__ */ e(
    "path",
    {
      clipRule: "evenodd",
      d: "M19.5 39C30.27 39 39 30.27 39 19.5S30.27 0 19.5 0 0 8.73 0 19.5 8.73 39 19.5 39zm12.173-25.625a3.053 3.053 0 00-2.148-2.148c-1.908-.502-9.538-.502-9.538-.502s-7.63 0-9.537.502a3.053 3.053 0 00-2.148 2.148C7.8 15.283 7.8 19.238 7.8 19.238s0 3.976.502 5.863a3.053 3.053 0 002.148 2.148c1.908.502 9.537.502 9.537.502s7.63 0 9.538-.502a3.051 3.051 0 002.148-2.148c.502-1.907.502-5.863.502-5.863s.02-3.975-.502-5.863zm-14.115 9.517v-7.308l6.325 3.654-6.325 3.654z",
      fill: "#fff",
      fillRule: "evenodd",
      opacity: 0.5
    }
  ) });
}
export {
  i as default
};
